module.exports = __webpack_public_path__ + "static/img/合约交易_图3.ac28a6e6.png";